<template>
  <main class="app__root">
    <CameraFeed />

    <PlasticLayer :background="tapped ? 'transparent' : 'black'" />

    <ModelLayer />

    <Loader v-if="!tapped" />

    <RotateDevice />
  </main>
</template>

<script>
import Loader from './components/Loader.vue';
import CameraFeed from './components/CameraFeed.vue';
import PlasticLayer from './components/PlasticLayer.vue';
import ModelLayer from './components/ModelLayer.vue';
import RotateDevice from './components/RotateDevice.vue';

export default {
  name: 'App',

  components: {
    Loader,
    CameraFeed,
    PlasticLayer,
    ModelLayer,
    RotateDevice,
  },

  data() {
    return {
      tapped: false,
    };
  },

  mounted() {
    window.addEventListener('tapped', () => {
      this.tapped = true;
    });
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Basis Grotesque Pro';
  src: url('/BasisGrotesquePro-Medium.woff2');
}
body {
  margin: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  font-family: 'Basis Grotesque Pro';
  font-size: 18px;
}
</style>
